<script>
// 화면 제목 영역(PageHeader) — 사내 디자인 시스템 규칙: 내용(제목 · 설명 · 버튼)은 «화면»이 정하고, 자리는 «셸»이 정한다.
// 화면 템플릿에 두면 제자리에는 아무것도 그리지 않고, 셸(관리자 layout-admin · 원청 AdminMaster)이 상단 바 아래 제목 자리에 그린다.
// Vue 2 에는 Teleport 가 없어 셸이 provide 한 adminShell 에 내용을 등록하는 방식으로 옮긴다.
// 셸 밖(예: 셸 없이 열리는 화면)에서는 제자리에 같은 모양으로 그린다.
//
// <admin-page-header title="벤더코드 관리" description="…">
//   <template #actions><b-btn …>추가</b-btn></template>   ← 버튼(선택)
//   <template #badge><b-badge …/></template>             ← 제목 옆 배지(선택)
//   <template #tabs><router-link class="ds-ph-tab" …/></template> ← 제목 판 아래쪽 탭(선택, 원청 프로젝트 · 캠페인 상세)
// </admin-page-header>
// contained: 본문이 가운데 고정폭(b-container)인 화면 — 제목도 같은 폭 안에 세워 본문과 세로선을 맞춘다
import AdminPageHeaderView from './AdminPageHeaderView.vue';

export default {
    name: 'AdminPageHeader',
    components: {AdminPageHeaderView},
    inject: {adminShell: {default: null}},
    props: {
        title: {type: String, required: true},
        description: {type: String, default: ''},
        // 제목 왼쪽 「나가는 길」 — { label: '목록으로', to: { name: … } } 또는 { label, onClick, disabled? }(주소로 못 적는 이동)
        back: {type: Object, default: null},
        contained: {type: Boolean, default: false},
    },
    computed: {
        header() {
            return {title: this.title, description: this.description, back: this.back, contained: this.contained};
        },
    },
    watch: {
        // 제목 · 설명 · 나가는 길이 바뀌면(셸 안에서는 render 가 props 를 안 읽어 다시 그려지지 않는다)
        header: {
            immediate: true,
            handler() {
                this.register();
            },
        },
    },
    // 🔴 슬롯(actions · badge)은 render 안에서야 최신으로 바뀐다(Vue 2 의 $scopedSlots 정규화 시점) —
    //   beforeUpdate 에서 등록하면 한 박자 늦은 슬롯이 셸에 남는다(판단 기준 화면의 loaded 배지가 안 보였다).
    //   그래서 그린 «뒤»(mounted · updated)에 등록한다
    mounted() {
        this.register();
    },
    updated() {
        this.register();
    },
    beforeDestroy() {
        if (this.adminShell) this.adminShell.clearPageHeader(this);
    },
    methods: {
        register() {
            if (!this.adminShell) return;
            this.adminShell.setPageHeader(this, {
                ...this.header,
                actions: this.$scopedSlots.actions || null,
                badge: this.$scopedSlots.badge || null,
                tabs: this.$scopedSlots.tabs || null,
            });
        },
    },
    render(h) {
        if (this.adminShell) return h();
        return h(AdminPageHeaderView, {props: {header: {...this.header, actions: this.$scopedSlots.actions, badge: this.$scopedSlots.badge, tabs: this.$scopedSlots.tabs}}});
    },
};
</script>
